import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import strings from '../../components/Language';
import { getAuthToken, getUserData, storeUserData } from '../../components/Util';
import axios from 'axios';
import api from '../../config/api';
import { images } from '../../config/image';
import { Button, Rate, Select, Spin } from 'antd';
import { toast } from 'react-toastify';
import { withRouter } from '../../config/withRouter';
import { ProgressBar } from 'react-loader-spinner';

class InstallerScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            hasMore: false,
            lang: strings.getLanguage(),
            access_token: null,
            isLoading: false,
            refreshing: false,
            data: [],
            next_page_url: null,
            prev_page_url: null,
            visibleItems: null,
            userDetails: null,
            username: '',
            profilePic: '',
            invoice_no: '',
            redirect: false,
            row_id: null,
            comment: '',
            rating: '',
            installerId: '',
            selectedFiles: [],
            city_id: null,
            city_loading: true,
            cities: [],
            message: {},
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
            self.getInstaller(api.InstallerList);
            self.getCities(api.Cities);
            setTimeout(() => {
                self.getInvoiceList();
                var userData = getUserData();
                self.setState({
                    userDetails: userData.data,
                    profilePic: userData.data.profile_url,
                    username: userData.data.username
                })
            });
        }
    }

    getCities(APIURL) {
        const self = this;
        self.setState({ city_loading: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({
                cities: (ress.data.message) ? ress.data.message : [],
                city_id: (ress.data.default_city_id) ? ress.data.default_city_id : '',
                city_loading: false
            })
        }).catch(function (erro) {
            self.setState({ city_loading: true });
        });
    }

    getInstaller(APIURL) {
        const self = this;
        self.setState({ refreshing: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ refreshing: false });
            self.setState({
                data: (ress.data.message && ress.data.message.data) ? ress.data.message.data : [],
                next_page_url: (ress.data.message && ress.data.message.next_page_url) ? ress.data.message.next_page_url : '',
                hasMore: (ress.data.message && ress.data.message.next_page_url) ? true : false,
                prev_page_url: (ress.data.message && ress.data.message.prev_page_url) ? ress.data.message.prev_page_url : ''
            })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ refreshing: false });
            self.setState({ ProgressBar: false });
        });
    }

    changeCity(city_id) {
        this.setState({
            data: [],
            next_page_url: '',
            hasMore: false,
            prev_page_url: ''
        })
        if (city_id) {
            this.getInstaller(api.InstallerList + "?city_id=" + city_id);
        } else {
            this.getInstaller(api.InstallerList);
        }
    }

    getNextPageData(APIURL) {
        const self = this;
        self.setState({ refreshing: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ refreshing: false });
            self.setState({
                data: (ress.data.message && ress.data.message.data) ? [...self.state.data, ...ress.data.message.data] : self.state.data,
                next_page_url: (ress.data.message && ress.data.message.next_page_url) ? ress.data.message.next_page_url : '',
                hasMore: (ress.data.message && ress.data.message.next_page_url) ? true : false,
                prev_page_url: (ress.data.message && ress.data.message.prev_page_url) ? ress.data.message.prev_page_url : ''
            })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ refreshing: false });
            self.setState({ ProgressBar: false });
        });
    }

    getInvoiceList() {
        const self = this;
        self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: api.InvoiceList,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ 'isLoading': false })
            self.setState({ 'invoiceList': ress.data.message })
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
        });
    }

    // Toggle visibility for a specific item
    toggleVisibility = (id) => {
        this.setState({ visibleItems: id, installerId: id });
    };

    applyInstaller() {
        const self = this;
        self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: api.InstallerApplyCheck,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ isLoading: false });
            if (ress.data.error == 202 || ress.data.error == '202') {
                if (ress.data.errors && ress.data.errors.length != 0) {
                    self.setState({ errorMessage: ress.data.errors });
                } else {
                    toast.error(ress.data.message);
                }
            } else {
                if (ress.data.can_allow) {
                    self.setState({ redirect: true });
                    return false;
                } else {
                    toast.error(ress.data.message);
                }
            }
        }).catch(function (error) {
            toast.error(strings["no_internet"]);
        });
    }

    handleFileChange = (event, arrayId) => {
        const file = event.target.files[0];
        var selectedFiles = this.state.selectedFiles;
        selectedFiles[arrayId] = file;
        this.setState({ selectedFiles: selectedFiles });
    };

    onPressSubmit() {
        const self = this;
        self.setState({ 'isLoading': true })
        if (self.state.invoice_no === '') {
            toast.error(strings["invoiceSelect"]);
            return false;
        }
        if (self.state.comment === '') {
            toast.error(strings["commentPlaceholder"]);
            return false;
        }

        let formData = new FormData();
        formData.append("row_id", self.state.installerId);
        formData.append("body", self.state.comment);
        formData.append("invoice_no", self.state.invoice_no);
        formData.append("rating", self.state.rating);
        formData.append("lang", self.state.lang);

        const attachments = self.state.selectedFiles.filter((item) => item && !(Array.isArray(item) && item.length === 0));
        formData.append("attachments", attachments);


        axios({
            method: 'POST',
            url: api.InstallerAddComment,
            data: formData,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'multipart/form-data',
            }
        }).then(function (response) {
            self.setState({ 'isLoading': false })
            if (response.data.error != 200) {
                toast.error(response.data.message);
            } else if (response.data.error === 200) {
                toast.success(response.data.message);
                self.setState({ visibleItems: null, comment: '', rating: '', invoice_no: null, installerId: '', selectedFiles: [], row_id: null });
                self.getInstaller(api.InstallerList);
                self.getInvoiceList();
            }
        }).catch(function (error) {
            self.setState({ 'isLoading': false });
        })
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to="/installer-apply" />;
        }
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <main className='installer-screen'>
                    <Header data={{ title: strings["navInstaller"] }} />
                    <div className="top-section">
                        <h1 id="installerTitle" className="installer-title">{strings["navInstaller"]}</h1>
                        <Link onClick={() => this.applyInstaller()} className="apply-button">
                            <span id="applyButton">{strings["applyButton"]}</span>
                        </Link>
                    </div>
                    {!this.state.city_loading ?
                        <div className="city-selection-section">
                            <div className="city-dropdown">
                                <Select
                                    suffixIcon={<img src={images["arrow-down"]} style={{ width: 24, height: 24, }} className="tick-icon" alt="" />}
                                    defaultValue={this.state.city_id}
                                    onChange={(data) => this.changeCity(data)}
                                    style={{ width: '100%' }}
                                >
                                    <Select.Option value="">{strings['SelectCity']}</Select.Option>
                                    {this.state.cities.map((item, i) => (
                                        <Select.Option key={"city_001_" + i} value={item.id} >{item.name}</Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                        : null}
                    <div className="installer-list" data-card-id="1">

                        {this.state.data.map((item, i) =>
                            <>
                                <div key={i} className="installer-card">
                                    {item.owner.pic_url ?
                                        <img className="installer-profile" src={item.owner.pic_url} alt='' />
                                        :
                                        <img className="installer-profile" src={images['profile-icon']} alt='' />
                                    }
                                    <div className="installer-info">
                                        <h2>{item.company}</h2>
                                        <p>{item.mobile}</p>
                                        <div>{strings["Ratings"]} {(item.avg_rating > 0) ? <Rate disabled defaultValue={item.avg_rating} /> : strings["(no rating)"]}</div>
                                        <div className="button-wrap">
                                            <Link to={`/installer-detail/${item.id}`} id="detailsButton" className="details-button">{strings["detailsButton"]}</Link>
                                            <button onClick={() => this.toggleVisibility(item.id)} id="reviewButton" className="review-button">
                                                {strings["reviewButton"]}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {this.state.visibleItems == item.id ?
                                    <div key={i + "_002"} className="installer-card">
                                        <div className="installer-card">
                                            {this.state.profilePic ?
                                                <img className="installer-profile" src={this.state.profilePic} alt='' />
                                                :
                                                <img className="installer-profile" src={images['profile-icon']} alt='' />
                                            }
                                            <div className="wrap-review">
                                                <p className="number"> {this.state.username} </p>
                                                <div className="invoice-wrap">
                                                    <label id="invoiceLabel">{strings["invoiceLabel"]}</label>
                                                    <div className="custom-dropdown">
                                                        <div id="invoiceSelect" className="dropdown-selected">{strings["invoiceSelect"]}</div>
                                                        <Select defaultValue={this.state.invoice_no} onChange={(invoice_no) => this.setState({ invoice_no: invoice_no })} style={{ width: "100%" }}>
                                                            <Select.Option value="">{strings["invoiceSelect"]}</Select.Option>
                                                            {this.state.invoiceList.map((item, i) => (
                                                                <Select.Option key={i + 200} value={item.invoice_no} >{item.invoice_no}</Select.Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>
                                                <div className="rating-wrap">
                                                    <label id="ratingLabel"> {strings["ratingLabel"]} </label>
                                                    <div className="star-rating">
                                                        <Rate onChange={(rating) => this.setState({ rating: rating })} defaultValue={0} />
                                                    </div>
                                                </div>

                                                <div className="comment-wrap">
                                                    <label id="commentLabel"> {strings["commentLabel"]} </label>
                                                    <textarea onChange={(e) => this.setState({ comment: e.target.value })} className="review-comment" id="commentPlaceholder" placeholder={strings["commentPlaceholder"]}></textarea>
                                                </div>
                                                <div className="upload-wrap">
                                                    <div>
                                                        <input onChange={(e) => this.handleFileChange(e, 0)} type="file" id="uploadImage1" className="image-input" accept="image/*" />
                                                        <label htmlFor="uploadImage1" id="uploadLabel" className="photo-upload">
                                                            {this.state.selectedFiles[0] ?
                                                                <img
                                                                    key={0}
                                                                    src={URL.createObjectURL(this.state.selectedFiles[0])}
                                                                    alt={`Preview ${0}`}
                                                                    style={{ width: 40, height: 40 }}
                                                                />
                                                                :
                                                                <>{strings["uploadLabel"]}</>
                                                            }
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <input onChange={(e) => this.handleFileChange(e, 1)} type="file" id="uploadImage2" className="image-input" accept="image/*" />
                                                        <label htmlFor="uploadImage2" id="uploadLabel" className="photo-upload">
                                                            {this.state.selectedFiles[1] ?
                                                                <img
                                                                    key={1}
                                                                    src={URL.createObjectURL(this.state.selectedFiles[1])}
                                                                    alt={`Preview ${1}`}
                                                                    style={{ width: 40, height: 40 }}
                                                                />
                                                                :
                                                                <>{strings["uploadLabel"]}</>
                                                            }
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <input onChange={(e) => this.handleFileChange(e, 2)} type="file" id="uploadImage3" className="image-input" accept="image/*" />
                                                        <label htmlFor="uploadImage3" id="uploadLabel" className="photo-upload">
                                                            {this.state.selectedFiles[2] ?
                                                                <img
                                                                    key={2}
                                                                    src={URL.createObjectURL(this.state.selectedFiles[2])}
                                                                    alt={`Preview ${2}`}
                                                                    style={{ width: 40, height: 40 }}
                                                                />
                                                                :
                                                                <>{strings["uploadLabel"]}</>
                                                            }
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <input onChange={(e) => this.handleFileChange(e, 3)} type="file" id="uploadImage4" className="image-input" accept="image/*" />
                                                        <label htmlFor="uploadImage4" id="uploadLabel" className="photo-upload">
                                                            {this.state.selectedFiles[3] ?
                                                                <img
                                                                    key={3}
                                                                    src={URL.createObjectURL(this.state.selectedFiles[3])}
                                                                    alt={`Preview ${3}`}
                                                                    style={{ width: 40, height: 40 }}
                                                                />
                                                                :
                                                                <>{strings["uploadLabel"]}</>
                                                            }
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="button-wrap">
                                                    <button id="submitButton" onClick={() => this.onPressSubmit()} className="submit-button">{strings["submitButton"]}</button>
                                                    <button id="closeButton" onClick={() => this.toggleVisibility('')} className="close-button">{strings["closeButton"]}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }
                            </>
                        )}

                        <div className='load-more'>
                            {this.state.refreshing && <Spin />}
                            {this.state.hasMore && !this.state.refreshing && (
                                <Button type="submit" id="loginButton" className="load-more-button" loading={this.state.isLoading} onClick={() => this.getNextPageData(this.state.next_page_url ? this.state.next_page_url : '')}>
                                    {strings['Load More']}
                                </Button>
                            )}
                            {(!this.state.refreshing && this.state.data && this.state.data.length <= 0) ?
                                <p>{strings["No more data to load"]}</p>
                                : null}
                        </div>

                    </div>
                    <Footer />

                </main>
            </>
        );
    }
}

export default withRouter(InstallerScreen);
